// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1ERk4","buttons":"SendReceipts_buttons__r6mKi","email":"SendReceipts_email__2TWFM","bookApptTitle":"SendReceipts_bookApptTitle__3V-Pi"};